import React from 'react';
import { Dialog } from "@vitalsource/vstui";
import Dispatcher from "../../dispatcher";
import { toastUtils } from "../../utils/toast-utils";

class CopyURL extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this._copyText = this._copyText.bind(this);
    this._closeModal = this._closeModal.bind(this);
  }

  _closeModal() {
    this.props.onClose 
      ? this.props.onClose() 
      : Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  }

  _copyText(e) {
    e.preventDefault();
    if (Fraction.Helpers.copyEnabled()){
      Fraction.Helpers.copyText(this.props.link);
      Fraction.Reporter.gaEvent("reader/options/link-copied");
      this._closeModal();
      toastUtils.notify(
        i18n.t('citations.page-url-copied'),
        { type: "success" }
      );
    }
  }

  render() {
    return (
      <Dialog
        closeButtonLabel={i18n.t('base.close')}
        open
        primaryActionButton={{
          label: i18n.t('reader.notebook.copy'),
          onClick: this._copyText,
        }}
        secondaryActionButton={{
          label: i18n.t('base.cancel'),
          onClick: this._closeModal,
        }}
        onRequestClose={this._closeModal}
        size="medium"
        rootSelector="#bookshelf"
        title={i18n.t('citations.copy-page-url')}
      >
        <div className="citations link">
          <div className="citation-output">{this.props.link}</div>
        </div>
      </Dialog>
    );
  }
}

export default CopyURL;
